
module.exports = function ConditionalDisableWidget (host, config) {

  log('new ConditionalDisableWidget');

  var disabledValues = config.conditionalValues.split(',');

  var $select = $(host);
  var $target = $(config.targetInput);

  function update () {
    log($select.val());
    log(contains(disabledValues, $select.val())) ;

    if (contains(disabledValues, $select.val())) {
      $target.attr('disabled', true);
    } else {
      $target.attr('disabled', null);
    }
  }

  // Listeners
  $select.on('change', update);

  // Init
  update();

}

